/**
 * App Store + Google Play download badges.
 */
const APP_STORE_URL = "https://apps.apple.com/app/joble/id6651849610";
const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.jobpro.joble";

const STORES = [
  {
    href: APP_STORE_URL,
    icon: "ri-apple-fill",
    top: "Download on the",
    bottom: "App Store",
    label: "Download the Joble app on the App Store",
    chipClass: "bg-foreground-950 text-background-50",
  },
  {
    href: PLAY_STORE_URL,
    icon: "ri-google-play-fill",
    top: "Get it on",
    bottom: "Google Play",
    label: "Get the Joble app on Google Play",
    chipClass: "bg-accent-500 text-foreground-950",
  },
];

interface StoreBadgesProps {
  /** Center the badges, or keep them left-aligned. */
  justify?: "start" | "center";
  /** Lay the badges out in a row (default) or stacked in a column. */
  direction?: "row" | "col";
  /** Stretch each badge to full width — handy inside narrow columns. */
  fullWidth?: boolean;
  className?: string;
}

export default function StoreBadges({
  justify = "start",
  direction = "row",
  fullWidth = false,
  className = "",
}: StoreBadgesProps) {
  return (
    <div
      className={`flex ${
        direction === "col" ? "flex-col" : "flex-row flex-wrap"
      } ${justify === "center" ? "justify-center" : "justify-start"} gap-2.5 ${className}`}
    >
      {STORES.map((store) => (
        <a
          key={store.bottom}
          href={store.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={store.label}
          className={`group inline-flex items-center gap-2.5 rounded-full border border-background-300/50 bg-background-50 pl-1.5 pr-4 py-1.5 hover:-translate-y-0.5 hover:border-primary-400 hover:bg-background-100/70 transition-all duration-200 cursor-pointer ${
            fullWidth ? "w-full" : ""
          }`}
        >
          <span
            className={`w-8 h-8 shrink-0 rounded-full flex items-center justify-center ${store.chipClass}`}
          >
            <i className={`${store.icon} text-base`} aria-hidden></i>
          </span>
          <span className="flex flex-col text-left leading-none">
            <span className="text-[10px] tracking-wide text-foreground-500">{store.top}</span>
            <span className="text-sm font-semibold text-foreground-950 mt-0.5">
              {store.bottom}
            </span>
          </span>
        </a>
      ))}
    </div>
  );
}